// extracted by mini-css-extract-plugin
module.exports = {"petCardContainer":"_3b8bJ","title":"_1pgm1","showButton":"_1ZtAY","infoWrapper":"_3_BaO","infoText":"_2oINo","moreButton":"_11eei","active":"_1OEsl"};